import React from 'react';
import { Modal } from 'edcom-ui';
import styles from './InteractiveWorksheetsTooltip.module.less';

function InteractiveWorksheetsTooltip(modalIsOpen, closeModal) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => closeModal(false)}
      size="auto"
      className="iw-tooltip"
    >
      <div className={styles.interactiveTooltip}>
        <div className={styles.container}>
          <div className={styles.header}>What are Interactive Worksheets?</div>
          <div className={styles.text}>
            <span>
              Interactive Worksheets bring printable worksheets to life!
              Students can complete worksheets online, and get instant feedback
              to improve.
            </span>
          </div>
          <div className={styles.header}>How do they work?</div>
          <div className={styles.text}>
            <span>
              Open an Interactive Worksheet, and create a direct link to share
              with students. They’ll enter their code to access the worksheet,
              complete it online, and get instant feedback. You can keep track
              of submissions in My Assignments.
            </span>
          </div>
          <div className={styles.link}>
            <a href="/interactive-worksheets-overview/">
              Learn more about Interactive Worksheets
            </a>
          </div>
          <div className={styles.imageHolder}>
            <img
              className={styles.image}
              src="https://cdn.education.com/files/static/interactive-worksheets/examples/example-for-tooltip.png"
              alt="example interactive worksheet"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default InteractiveWorksheetsTooltip;
